<template>
	<template v-if="isExpandable">
		<div
			v-if="text"
			data-type="richtext"
			class="rich"
			:class="{ closed: !opened && isExpandable }"
		>
			<DsText
				text-type="body-sm"
				text-style="regular"
				html-element="div"
				class="c-form-richtext"
			>
				<DsIcon v-if="icon" :icon-name="icon" size="sm"></DsIcon>
				<div data-testid="text" v-html="props.text"></div>
			</DsText>
			<DsButton variant="link" @click.prevent="toggle">{{
				opened ? readLessLabel : readMoreLabel
			}}</DsButton>
		</div>
	</template>
	<template v-else>
		<DsText
			text-type="body-sm"
			text-style="regular"
			html-element="div"
			class="c-form-richtext"
		>
			<DsIcon v-if="icon" :icon-name="icon" size="sm"></DsIcon>
			<div
				data-testid="text"
				v-if="text"
				data-type="richtext"
				v-html="text"
			></div>
		</DsText>
	</template>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { DsButton, DsIcon, DsText } from "@coloplast/design-system";
import type { RichTextHtmlElementProps } from "./RichTextHtmlElement.types";

const props = withDefaults(defineProps<RichTextHtmlElementProps>(), {
	isExpandable: false,
});

const opened = ref(false);

function toggle() {
	opened.value = !opened.value;
}
</script>

<style lang="scss">
@import "multisite/styles/settings/settings";
@import "multisite/styles/tools/tools";

.c-form-richtext {
	color: ds-color(fg, muted);
	display: flex;
	max-inline-size: 591px;
	gap: ds-gap(2);

	p:last-child {
		margin: 0;
	}
}

div[data-type="richtext"] {
	> div {
		max-height: 400px;
		overflow: hidden;
		transition: max-height t-duration("medium-2");
	}

	&.closed {
		> div {
			max-height: 50px;

			p {
				display: -webkit-box;
				animation: collapse;
				animation-duration: t-duration("medium-2");
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				overflow: hidden;
			}
		}
	}

	> button.ds-button.ds-button--link {
		padding: 0;
		text-align: left;
		display: block;
		margin-top: 8px;

		&,
		&:hover,
		&:active {
			text-decoration: none;
		}
	}
}

@keyframes collapse {
	0% {
		-webkit-line-clamp: initial;
	}

	90% {
		-webkit-line-clamp: initial;
	}

	100% {
		-webkit-line-clamp: 2;
	}
}
</style>
